import React, { useState, useEffect } from 'react'
import { Layout, Card, Col, Row, Spin, message } from 'antd'
import ds from '../Services/DataServices'
import { useHistory } from 'react-router-dom'
import { useStore, useDispatch, useSelector } from 'react-redux'
import Skeleton from 'react-loading-skeleton'
import IntlMessages from '../util/IntlMessages'
import { IntlProvider } from 'react-intl'
// import SetOutletPic from "../../src/assets/images/setUpOutlets.svg";
// import SetSaleTaxPic from "../../src/assets/images/setUpTaxes.svg";
// import SetPayementPic from "../../src/assets/images/setUpPayments.svg";
// import SetUserPic from "../../src/assets/images/setUpUsers.svg";
// import SetProductPic from "../../src/assets/images/setUpProducts.svg";
// import SetSellPic from "../../src/assets/images/setUpGetSelling.svg";

// import SetOutletPic from "../../src/assets/images/setUpOutlets.png";
// import SetSaleTaxPic from "../../src/assets/images/setUpTaxes.png";
// import SetPayementPic from "../../src/assets/images/setUpPayments.png";
// import SetUserPic from "../../src/assets/images/setUpUsers.png";
// import SetProductPic from "../../src/assets/images/setUpProducts.png";
// import SetSellPic from "../../src/assets/images/setUpGetSelling.png";

import SetSellPic from '../../src/assets/images/UI_img6.png'
import SetProductPic from '../../src/assets/images/UI_img5.png'
import SetUserPic from '../../src/assets/images/UI_img4.png'
import SetOutletPic from '../../src/assets/images/UI_img1.png'
import SetPayementPic from '../../src/assets/images/UI_img3.png'
import SetSaleTaxPic from '../../src/assets/images/UI_img2.png'

import {
  isEmptyObject,
  checkRightspermissions,
  checkScreenAccess
} from '../appRedux/actions/GlobalMethods'
import { setCommonConfigs } from '../appRedux/actions/CommonData'
import {
  HOME,
  MAIN_SALE_SCREEN,
  OPEN_CLOSE,
  SALE_HISTORY,
  CASH_LISTING,
  STATUS,
  SELL_SETTING,
  PRODUCT_SCREEN,
  USERROLES_SCREEN,
  OUTLETREGISTER_SCREEN,
  TAX_SCREEN,
  PAYMENT_SCREEN
} from '../constants/Pages'
// import { REACT_APP_BUS_FIRST_NAME } from '../constants/StoreSetting'
import { env } from '../env'
import NotAllowedComponent from './NotAllowedComponent'

const { REACT_APP_BUS_FIRST_NAME } = env

const HomeCards = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { Meta } = Card

  const getReduxStoreInfo = useSelector(
    ({ commonConfigs }) => commonConfigs.getStoreInfo
  )
  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )
  const getIsMenuLoaded = useSelector(({ auth }) => auth.reloadMenu)

  const [visible, setVisible] = React.useState(false)
  const [getIsDisableCreate, setIsDisableCreate] = useState(true)
  const [getIsDisableUpdate, setIsDisableUpdate] = useState(true)
  const [getIsDisableDelete, setIsDisableDelete] = useState(true)
  const [getIsAllowRead, setIsAllowRead] = useState(false)
  const [getAccessLoading, setAccessLoading] = useState(true)
  const [getRights, setRights] = useState([])
  const [getPermissions, setPermissions] = useState([])
  const [getCurrData, setCurrData] = useState({
    currencyCode: '',
    currencySymbol: ''
  })

  //for common data -> store currency
  //const DeleteContext = createContext();
  useEffect(() => {
    let mounted = true
    if (mounted) {
      dispatch(setCommonConfigs(HOME))
    }

    return () => (mounted = false)
  }, [])

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      const commonData = getReduxCommonSetting
      const respData =
        commonData &&
        commonData.storeCommonConfigs &&
        commonData.storeCommonConfigs.storeConfig
          ? commonData.storeCommonConfigs.storeConfig
          : {}
      if (respData && respData.currencyData) {
        let currencyData = respData.currencyData
        setCurrData(currencyData)
      }
      // rights && permissions
      if (commonData && commonData.storeCommonConfigs) {
        const rpData = checkRightspermissions(commonData)
        if (rpData && !isEmptyObject(rpData)) {
          setupRightsPermissions(rpData)
          setAccessLoading(false)
        } else {
          toInitialState()
          setAccessLoading(false)
        }
      }
    }

    return () => (mounted = false)
  }, [getReduxCommonSetting])

  function toInitialState () {
    setRights([])
    setPermissions([])
    setIsAllowRead(false)
    setIsDisableCreate(true)
    setIsDisableUpdate(true)
    setIsDisableDelete(true)
    setAccessLoading(true)
  }

  function setupRightsPermissions (rpData) {
    if (rpData.rights && rpData.rights.length > 0) {
      setRights(rpData.rights)
    } else {
      setRights([])
    }
    if (rpData.permissions && rpData.permissions.length > 0) {
      setPermissions(rpData.permissions)
    } else {
      setPermissions([])
    }
    if (rpData.read) {
      setIsAllowRead(true)
    } else {
      setIsAllowRead(false)
    }
    if (rpData.create) {
      setIsDisableCreate(false)
    } else {
      setIsDisableCreate(true)
    }
    if (rpData.update) {
      setIsDisableUpdate(false)
    } else {
      setIsDisableUpdate(true)
    }
    if (rpData.delete) {
      setIsDisableDelete(false)
    } else {
      setIsDisableDelete(true)
    }
  }

  const notAllowMsg = 'Sorry you do not have Access...'

  // return getIsAllowRead ? (
  return getIsAllowRead ? (
    <Spin
      tip={<IntlMessages id='sell.cashlisting.cashloading' />}
      spinning={!getIsMenuLoaded}
      size='large'
    >
      <Row style={{ marginTop: -18 }} justify='center'>
        <Col>
          <h1>
            {getReduxStoreInfo && getReduxStoreInfo.storeName ? (
              <>
                <IntlMessages id='dashbaord.main.title1' />
                <strong>{` ${getReduxStoreInfo.storeName}`}</strong>
              </>
            ) : (
              'Welcome'
            )}
          </h1>
        </Col>
      </Row>

      {getReduxStoreInfo && getReduxStoreInfo.userName && (
        <Row justify='center'>
          <Col>
            <h2>
              <IntlMessages
                id='dashbaord.main.title2'
                values={{
                  strong: chunks => <strong>{chunks}</strong>,
                  title: getReduxStoreInfo.userName
                }}
              />
            </h2>
          </Col>
        </Row>
      )}

      <Row style={{ marginBottom: 18 }} justify='center'>
        <Col>
          <h3>
            <IntlMessages id='dashbaord.main.title3' />
          </h3>
        </Col>
      </Row>

      <Row
        style={{
          marginTop: 'auto',
          marginLeft: '70px',
          marginRight: '70px'
        }}
      >
        <Col xl={8} lg={12} md={12} sm={24} xs={24}>
          <Card
            hoverable
            cover={<img alt='example' src={SetSellPic} />}
            onClick={() => {
              if (checkScreenAccess(MAIN_SALE_SCREEN)) {
                history.push('/dashboard/sell/mainsale/webregister')
              } else {
                message.info(notAllowMsg)
              }
            }}
          >
            <Meta
              title={<IntlMessages id='dashbaord.main.readyselltitle' />}
              description={<IntlMessages id='dashbaord.main.readyselldesc' />}
            />
          </Card>
        </Col>

        <Col xl={8} lg={12} md={12} sm={24} xs={24}>
          <Card
            hoverable
            cover={<img alt='example' src={SetProductPic} />}
            onClick={() => {
              if (checkScreenAccess(PRODUCT_SCREEN)) {
                history.push('/dashboard/products/main/listing')
              } else {
                message.info(notAllowMsg)
              }
            }}
          >
            <Meta
              title={<IntlMessages id='dashbaord.main.prodtitle' />}
              description={<IntlMessages id='dashbaord.main.proddesc' />}
            />
          </Card>
        </Col>

        <Col xl={8} lg={12} md={12} sm={24} xs={24}>
          <Card
            onClick={() => {
              if (checkScreenAccess(USERROLES_SCREEN)) {
                history.push('/dashboard/Setup/Users/listing')
              } else {
                message.info(notAllowMsg)
              }
            }}
            hoverable
            cover={<img alt='example' src={SetUserPic} />}
          >
            <Meta
              title={<IntlMessages id='dashbaord.main.usertitle' />}
              description={
                <IntlMessages
                  id='dashbaord.main.userdesc'
                  values={{
                    strong: chunks => <strong>{chunks}</strong>,
                    bus_name_first: REACT_APP_BUS_FIRST_NAME
                  }}
                />
              }
            />
          </Card>
        </Col>

        <Col xl={8} lg={12} md={12} sm={24} xs={24}>
          <Card
            onClick={() => {
              if (checkScreenAccess(OUTLETREGISTER_SCREEN)) {
                history.push('/Dashboard/Setup/outletsandregisters/listing')
              } else {
                message.info(notAllowMsg)
              }
            }}
            hoverable
            cover={<img alt='example' src={SetOutletPic} />}
          >
            <Meta
              title={
                <IntlMessages id='dashboard.dashboard.setupoutletsandregisters' />
              }
              description={
                <IntlMessages id='dashboard.dashboard.setupoutletsdescp' />
              }
            />
          </Card>
        </Col>

        <Col xl={8} lg={12} md={12} sm={24} xs={24}>
          <Card
            hoverable
            cover={<img alt='example' src={SetSaleTaxPic} />}
            onClick={() => {
              if (checkScreenAccess(TAX_SCREEN)) {
                history.push('/dashboard/Setup/SalesTax/listing')
              } else {
                message.info(notAllowMsg)
              }
            }}
          >
            <Meta
              title={<IntlMessages id='dashboard.dashboard.organizesaletax' />}
              description={
                <IntlMessages id='dashboard.dashboard.organizesaletaxdescp' />
              }
            />
          </Card>
        </Col>

        <Col xl={8} lg={12} md={12} sm={24} xs={24}>
          <Card
            hoverable
            cover={<img alt='example' src={SetPayementPic} />}
            onClick={() => {
              if (checkScreenAccess(PAYMENT_SCREEN)) {
                history.push('/dashboard/Setup/PaymentTypes/main')
              } else {
                message.info(notAllowMsg)
              }
            }}
          >
            <Meta
              title={<IntlMessages id='dashboard.dashboard.diffpaymenttypes' />}
              description={
                <IntlMessages id='dashboard.dashboard.diffpaymenttypesdescp' />
              }
            />
          </Card>
        </Col>
      </Row>
    </Spin>
  ) : (
    <NotAllowedComponent getAccessLoading={getAccessLoading} textType={1} />
  )
}

export default HomeCards
